// src/pages/Hhr.js
// Hhr.js - Updated loading state
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ResidentSidebar from '../components/ResidentSidebar';
import EditablePage from '../components/EditablePage';
import { getPageContent, savePageContent } from '../components/pageContentService';
import '../css/Basispagina.css';

const Hhr = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'nl');
  const [pageContent, setPageContent] = useState({
    title: 'Huishoudelijk Reglement & Splitsingsakte',
    titleEn: 'House Rules & Deed of Division',
    bodyHtml: '<p>Op deze pagina vind je linkjes naar belangrijke documenten die de basis vormen voor onze VVE.</p>',
    bodyHtmlEn: '<p>On this page you will find links to important documents that form the basis for our HOA.</p>'
  });
  const [loading, setLoading] = useState(true);
  const isAuthenticated = !!localStorage.getItem('token');

  // Load page content
  useEffect(() => {
    const loadPageContent = async () => {
      try {
        setLoading(true);
        const content = await getPageContent('hhr');
        console.log("Loaded HHR content:", content);
        
        // Update state with retrieved content, keeping defaults for empty values
        setPageContent({
          title: content.title || 'Huishoudelijk Reglement & Splitsingsakte',
          titleEn: content.titleEn || 'House Rules & Deed of Division',
          bodyHtml: content.bodyHtml || '<p>Op deze pagina vind je linkjes naar belangrijke documenten die de basis vormen voor onze VVE.</p>',
          bodyHtmlEn: content.bodyHtmlEn || '<p>On this page you will find links to important documents that form the basis for our HOA.</p>'
        });
      } catch (error) {
        console.error('Error loading page content:', error);
        // Keep default content if error
      } finally {
        setLoading(false);
      }
    };

    loadPageContent();
  }, []);

  // Get title based on language
  const getTitle = () => {
    if (language === 'en' && pageContent.titleEn) {
      return pageContent.titleEn;
    }
    return pageContent.title || 'Huishoudelijk Reglement & Splitsingsakte';
  };

  // Get content based on language
  const getBodyHtml = () => {
    if (language === 'en' && pageContent.bodyHtmlEn) {
      return pageContent.bodyHtmlEn;
    }
    return pageContent.bodyHtml || '<p>Op deze pagina vind je linkjes naar belangrijke documenten die de basis vormen voor onze VVE.</p>';
  };

  // Handle saving content
  const handleSaveContent = async (updatedContent) => {
    try {
      console.log("Saving HHR content:", updatedContent); // Debug
      
      // Save to both state and backend
      setPageContent(updatedContent);
      
      // Also save to localStorage as immediate backup
      localStorage.setItem(`vve_hhr_cache`, JSON.stringify(updatedContent));
      
      const success = await savePageContent('hhr', updatedContent);
      
      if (success) {
        alert('Content saved successfully!');
      } else {
        alert('Content saved locally. Changes will be visible but not synced to server.');
      }
    } catch (error) {
      console.error('Error saving page content:', error);
      alert('Error saving content to server, but content is saved locally.');
    }
  };

  if (loading) {
    return (
      <div className="page-with-sidebar">
        <ResidentSidebar language={language} setLanguage={setLanguage} />
        
        <div className="main-content hhr-page-content" style={{ backgroundColor: '#f8fff4' }}>
          <div className="info-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
          
          </div>
          
          <footer className="page-footer">
            <p>&copy; {new Date().getFullYear()} VVE Polderzicht • <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
          </footer>
        </div>
      </div>
    );
  }

  return (
    <div className="page-with-sidebar">
      <ResidentSidebar language={language} setLanguage={setLanguage} />
      
      <div className="main-content hhr-page-content">
        <div className="info-container">
          {/* Editable page component */}
          <EditablePage
            pageType="hhr"
            content={pageContent}
            onSave={handleSaveContent}
            language={language}
            isAuthenticated={isAuthenticated}
          />
          
          {/* Render the page title */}
          <h1>{getTitle()}</h1>
          
          {/* Render the editable content */}
          <div 
            className="page-content"
            dangerouslySetInnerHTML={{ __html: getBodyHtml() }} 
          />
          
          {/* Static content - links to documents */}
          <h2>{language === 'en' ? 'Deed of Division' : 'Splitsingsakte'}</h2>
          <p>{language === 'en' ? 'The deed of division is the highest ranking document. It was re-established at the notary in 2017.' : 'De splitsingsakte is het hoogste document in rang. Het is in 2017 opnieuw vastgelegd bij de notaris.'}</p>
          <button 
            className="widget-button"
            onClick={() => window.open('https://drive.google.com/file/d/1XeSUMAksHsxd4jurjqNCbL5nRvNjyqTV/view?usp=drive_link', '_blank', 'noopener,noreferrer')}
          >
            {language === 'en' ? 'View the Deed of Division' : 'Bekijk de Splitsingsakte'}
          </button>
          
          <h2>{language === 'en' ? 'House Rules' : 'Huishoudelijk Reglement'}</h2>
          <p>{language === 'en' ? 'In addition, there are our house rules, which contain supplementary rules. You can find them here:' : 'Daarnaast is er ons huishoudelijke reglement, daarin staan aanvullende regels. Je kunt dit hier vinden:'}</p>
          <button 
            className="widget-button"
            onClick={() => window.open('https://drive.google.com/file/d/1O4FB7YBGOWsMXv3WAG6visE4xASc13dQ/view?usp=drive_link', '_blank', 'noopener,noreferrer')}
          >
            {language === 'en' ? 'View the House Rules' : 'Bekijk het Huishoudelijk Reglement'}
          </button>
        </div>
        
        <footer className="page-footer">
          <p>&copy; {new Date().getFullYear()} VVE Polderzicht • <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
        </footer>
      </div>
    </div>
  );
};

export default Hhr;